import Vue from 'vue';
import store from './../../store';
import projectTransformer from './../../transformers/project';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

/* eslint no-console: ["error", { allow: ["log", "error"] }] */
const success = ({ data }, resolve) => {
  const projects = projectTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);
  store.dispatch('fetchProjects', { projects, pagination });
  resolve({ projects, pagination });
};

const failed = (error, reject) => reject(error);


export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/projects', options))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/project/items.js